import { render, staticRenderFns } from "./NeighbourhoodLabelsItem.vue?vue&type=template&id=0fa912ee&scoped=true&"
import script from "./NeighbourhoodLabelsItem.vue?vue&type=script&lang=js&"
export * from "./NeighbourhoodLabelsItem.vue?vue&type=script&lang=js&"
import style0 from "./NeighbourhoodLabelsItem.vue?vue&type=style&index=0&id=0fa912ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa912ee",
  null
  
)

export default component.exports